module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', [_vm._m(0), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-5 order-lg-2"
  }, [_c('div', {
    staticClass: "p-5"
  }, [_c('img', {
    staticClass: "img-fluid rounded-circle",
    attrs: {
      "src": require('@/assets/images/play-conceptphoto.jpg'),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 order-lg-1",
    attrs: {
      "id": "whatisconcept"
    }
  }, [_c('div', {
    staticClass: "p-5"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('b-link', {
    attrs: {
      "href": "https://amzn.to/2HRnvtq",
      "target": "_blank"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "lg"
    }
  }, [_vm._v("Acheter le jeu")])], 1)], 1)])])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [_c('div', {
    staticClass: "p-5"
  }, [_c('img', {
    staticClass: "img-fluid rounded-circle",
    attrs: {
      "src": require('@/assets/images/concept-digital.jpg'),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "p-5"
  }, [_c('h2', {
    staticClass: "display-4"
  }, [_vm._v("Et en version digitale alors ?")]), _vm._v(" "), _c('p', [_vm._v("Ce site est un hommage à cet excellent jeu de société, il vous permet de jouer dans différentes configurations : tous autour d'une même tablette ou d'un même ordinateur, autour d'une même \"partie virtuelle\" où tout le monde voit les cartes proposés sur son ordinateur, tablette ou smartphone (que vous soyiez au même endroit ou non ou encore de créer des \"plateaux de jeu\" ou deviner ceux des autres.")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "lg"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Mainboard'
        })
      }
    }
  }, [_vm._v("Découvrir le plateau")])], 1)])])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-5 order-lg-2"
  }, [_c('div', {
    staticClass: "p-5"
  }, [_c('img', {
    staticClass: "img-fluid rounded-circle",
    attrs: {
      "src": require('@/assets/images/play-multiplayers-square.jpg'),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 order-lg-1"
  }, [_c('div', {
    staticClass: "p-5"
  }, [_c('h2', {
    staticClass: "display-4"
  }, [_vm._v("Jouer à plusieurs en même temps (live)...")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "lg"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Mainboard'
        })
      }
    }
  }, [_vm._v("Jouer en live")])], 1)])])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [_c('div', {
    staticClass: "p-5"
  }, [_c('img', {
    staticClass: "img-fluid rounded-circle",
    attrs: {
      "src": require('@/assets/images/play-singleplayer-square.jpg'),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "p-5"
  }, [_c('h2', {
    staticClass: "display-4"
  }, [_vm._v("... ou chacun son tour (solo)")]), _vm._v(" "), _c('p', [_vm._v("Grâce à cette version digitale, vous pouvez construire des plateaux de jeu avec des icônes associées à chaque ligne de concept. L'objectif reste identique : faire deviner des mots aux autres joueurs.")]), _vm._v(" "), _c('p', [_vm._v("Vous pouvez également tenter de découvrir les mots cachés par les plateaux créés par les autres joueurs. Pour accéder à ce mode de jeu, vous devez vous connecter.")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "lg"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Mainboard'
        })
      }
    }
  }, [_vm._v("Se connecter")])], 1)])])])])]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "masthead text-center text-white"
  }, [_c('div', {
    staticClass: "masthead-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "masthead-heading mb-0"
  }, [_vm._v("Concept, version digitale")]), _vm._v(" "), _c('h2', {
    staticClass: "masthead-subheading mb-0"
  }, [_vm._v("Et ça décoiffe du poney au petit matin")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-xl rounded-pill mt-5",
    attrs: {
      "href": "#whatisconcept"
    }
  }, [_vm._v("En savoir plus")])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-circle-1 bg-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-circle-2 bg-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-circle-3 bg-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-circle-4 bg-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "display-4"
  }, [_vm._v("C'est quoi "), _c('i', [_vm._v("Concept")]), _vm._v(" ?")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Concept est un jeu de société sur plateau. Le but est de faire découvrir aux autres joueurs un mot proposé par le jeu. Pour cela, le joueur dispose uniquement du jeu d'icônes symboliques présentes sur le plateau. En associant astucieusement ces icônes sur différents "), _c('i', [_vm._v("concepts")]), _vm._v(", le joueur peut ainsi faire deviner les autres joueurs.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Cette version digitale de "), _c('i', [_vm._v("Concept")]), _vm._v(" vous propose le plateau d'icônes du jeu de société, vous pouvez l'utiliser comme sur le jeu physique pour faire deviner des mots. Piochez des mots au hasard (pensez à masquer votre écran) en cliquant sur la carte "), _c('i', [_vm._v("Concept")]), _vm._v(" et lancez-vous !")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "py-5 bg-black"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "m-0 text-center text-white small"
  }, [_vm._v("Copyright © Concept Digital 2019")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b053580","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = 0bE+
// module chunks = 1